const images = document.querySelectorAll(".slider-img");
const imageSlider = document.getElementById("imageSlider");
const colors = document.querySelectorAll(".color-swatch");
const color_input = document.getElementById("colour_kit");
const lightbox = document.getElementById("lightbox");
const lightboxImg = document.getElementById("lightboxImg");
const prevBtn = document.querySelector(".lightbox-prev");
const nextBtn = document.querySelector(".lightbox-next");
const closeBtn = document.querySelector(".close");
const colorSwatchInputContainer = document.querySelector(".color-swatch-input-container");
const ProductPageAddToCartForm = document.getElementById("ProductPageAddToCartForm");
const ProductPageAddToCartBtn = document.querySelector(".add-to-cart-btn");
const thumbnailPicker = document.getElementById("thumbnailPicker");
const thumbnails = document.querySelectorAll(".thumbnail-item");
const dealerList = document.getElementById("dealerList");

let currentIndex = 0;
let isTransitioning = false;

colors.forEach((color) => {
  color.addEventListener("click", () => {
    activateColor(color);
  });
});

thumbnails.forEach((thumb, index) => {
  thumb.addEventListener("click", () => {
    goToSlide(index);
  });
});

// Open lightbox
images.forEach((img, index) => {
  img.addEventListener("click", () => {
    currentIndex = index;
    showImage();
    document.body.classList.add("no-scroll");
    lightbox.style.display = "block";
  });
});

function activateColor(color) {
  showColorCheckbox();
  color_input.setAttribute("data-color", color.dataset.color);
  deactivateColor();
  color.classList.add("active");
  goToSlide(color.getAttribute("data-index"));
}

function deactivateColor() {
  colors.forEach((color) => {
    color.classList.remove("active");
  });
}

function showColorCheckbox() {
  colorSwatchInputContainer.classList.add("show");
}

// Refresh the lightbox <img> to the current image (only matters while it's open).
function showImage() {
  const img = images[currentIndex];
  if (!img) return;
  const highRes = img.getAttribute("data-large") || img.src;
  lightboxImg.src = highRes;

  // Disable buttons at the boundaries (no wraparound)
  if (prevBtn) prevBtn.disabled = currentIndex === 0;
  if (nextBtn) nextBtn.disabled = currentIndex === images.length - 1;
}

// Single source of truth: move the carousel. The `slid.bs.carousel` handler
// below keeps currentIndex, the active thumbnail, and the lightbox in sync.
function goToIndex(index) {
  index = parseInt(index, 10);
  if (isNaN(index) || index < 0 || index >= images.length) return;
  $(imageSlider).carousel(index);
}

function showPrevImage() {
  if (currentIndex <= 0) return;
  currentIndex--;
  if (lightbox.style.display === "block") showImage(); // instant lightbox feedback
  $(imageSlider).carousel(currentIndex);               // sync carousel + thumbnail
}

function showNextImage() {
  if (currentIndex >= images.length - 1) return;
  currentIndex++;
  if (lightbox.style.display === "block") showImage();
  $(imageSlider).carousel(currentIndex);
}

function goToSlide(index) {
  goToIndex(index);
}

// Keep currentIndex, the thumbnails and the lightbox in lockstep whenever the
// main carousel changes — via its own arrows, a thumbnail click, a colour
// swatch, or the lightbox navigation. This is what makes everything move together.
$(imageSlider).on("slid.bs.carousel", function (e) {
  let idx = typeof e.to === "number" ? e.to : -1;
  if (idx < 0) {
    const items = imageSlider.querySelectorAll(".carousel-item");
    idx = Array.prototype.indexOf.call(
      items,
      imageSlider.querySelector(".carousel-item.active")
    );
  }
  if (idx < 0) return;
  currentIndex = idx;
  setActiveThumbnail(currentIndex);
  if (lightbox.style.display === "block") showImage();
});

/**
 * Set the active thumbnail and scroll the picker so the active thumb is visible.
 * Will not wrap around — scroll position is clamped to [0, maxScroll].
 */
function setActiveThumbnail(index) {
  if (!thumbnailPicker || !thumbnails.length) return;

  thumbnails.forEach((t) => t.classList.remove("active"));
  const activeThumb = thumbnails[index];
  if (!activeThumb) return;
  activeThumb.classList.add("active");

  const thumbOffsetLeft = activeThumb.offsetLeft;
  const thumbWidth = activeThumb.offsetWidth;
  const pickerWidth = thumbnailPicker.clientWidth;

  const rawTarget = thumbOffsetLeft - (pickerWidth / 2) + (thumbWidth / 2);
  const maxScroll = thumbnailPicker.scrollWidth - pickerWidth;
  const target = Math.max(0, Math.min(rawTarget, maxScroll));

  thumbnailPicker.scrollTo({
    left: target,
    behavior: "smooth",
  });
}

function setLoading(button) {
  // Store original text (optional, if you want to restore later)
  button.dataset.originalText = button.innerHTML;

  // Replace with loading spinner
  button.innerHTML = `
    <span class="spinner"></span>
  `;

  // Disable button to prevent multiple clicks
  button.disabled = true;
}

// Close lightbox
closeBtn.onclick = () => {
  document.body.classList.remove("no-scroll");
  lightbox.style.display = "none";
};

// Close on outside click
lightbox.onclick = (e) => {
  if (e.target !== lightboxImg) {
    document.body.classList.remove("no-scroll");
    lightbox.style.display = "none";
  }
};

if (prevBtn) {
  prevBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    showPrevImage();
  });
}
if (nextBtn) {
  nextBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    showNextImage();
  });
}

// Close on ESC
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    document.body.classList.remove("no-scroll");
    lightbox.style.display = "none";
  }
});

ProductPageAddToCartForm.onsubmit = async (e) => {
  e.preventDefault();
  setLoading(ProductPageAddToCartBtn);

  try {
    const formData = new FormData(e.target);

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    const data = await res.json();

    if (color_input.checked) {
      const colorFormData = new FormData();
      colorFormData.append('items[0][id]', color_input.value);
      colorFormData.append('items[0][quantity]', 1);
      colorFormData.append('items[0][properties][color]', color_input.getAttribute("data-color"));

      const res2 = await fetch('/cart/add.js', {
        method: 'POST',
        body: colorFormData
      });

      await res2.json();

      location.href = "/cart";
    } else {
      location.href = "/cart";
    }

  } catch (err) {
    console.error(err);
  }
};

const DEALER_CACHE_KEY = "dealer_locations_v1";
const DEALER_CACHE_TTL_MS = 24 * 60 * 60 * 1000; // refresh once a day
const USER_LOCATION_KEY = "user_location_v1";
const USER_LOCATION_TTL_MS = 60 * 60 * 1000; // 1 hour

const SHEET_ENDPOINT =
  "https://sheets.googleapis.com/v4/spreadsheets/1tF7cK3yj-bbWYE6BHzukXNWFm9eChkbLhVlXR-kSOL4/values:batchGet?key=AIzaSyClMBRNd8v7eUrFjuw38Rg-MeDwgfYO4sc&ranges=DEALERS STOCK!A2:ZZZ1000";

const MAX_DEALER_DISTANCE_KM = 50;

const FALLBACK_DEALER = {
  name: "Thumpstar Dunedin",
  contactName: "",
  email: "support@thumpstar.co.nz",
  phone: "09 889 6857",
  address: "270 Kaikorai Valley Road, Dunedin, 9011, New Zealand",
  latitude: -45.8740111,
  longitude: 170.4694756,
  status: "Active",
};

// Column indices in the sheet (0-based, matching the header row you pasted)
const COL = {
  name: 0,
  contactName: 1,
  email: 2,
  phone: 3,
  address: 4,
  about: 5,
  services: 6,
  image1: 7,
  image2: 8,
  latitude: 9,
  longitude: 10,
  status: 11
};

async function fetchDealerLocations({ forceRefresh = false } = {}) {
  if (!forceRefresh) {
    const cached = readCache(DEALER_CACHE_KEY, DEALER_CACHE_TTL_MS);
    if (cached) return cached;
  }

  const response = await fetch(SHEET_ENDPOINT);
  if (!response.ok) throw new Error(`Sheets API responded ${response.status}`);

  const data = await response.json();
  const rows = data.valueRanges?.[0]?.values ?? [];

  // Normalize: parse lat/lng, drop dealers without coords or marked inactive/removed
  const dealers = rows
    .map((row) => ({
      name: (row[COL.name] || "").trim(),
      contactName: row[COL.contactName] || "",
      email: row[COL.email] || "",
      phone: row[COL.phone] || "",
      address: row[COL.address] || "",
      latitude: parseFloat(row[COL.latitude]),
      longitude: parseFloat(row[COL.longitude]),
      status: (row[COL.status] || "").trim(),
    }))
    .filter(
      (d) =>
        d.status.toUpperCase() === "ACTIVE" &&
        Number.isFinite(d.latitude) &&
        Number.isFinite(d.longitude) &&
        d.name 
    );

  writeCache(DEALER_CACHE_KEY, dealers);
  return dealers;
}

/* ---------- User location: GPS first, IP fallback ---------- */

async function getUserLocation({ forceRefresh = false } = {}) {
  if (!forceRefresh) {
    const cached = readCache(USER_LOCATION_KEY, USER_LOCATION_TTL_MS);
    if (cached) return cached;
  }

  let location = await tryGPS();
  if (!location) location = await tryIP();
  if (!location) throw new Error("Could not determine user location");

  writeCache(USER_LOCATION_KEY, location);
  return location;
}

function tryGPS() {
  return new Promise((resolve) => {
    if (!("geolocation" in navigator)) return resolve(null);

    // Don't even attempt outside a secure context — browsers will reject it anyway.
    if (!window.isSecureContext) return resolve(null);

    const timeoutId = setTimeout(() => resolve(null), 8000);

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        clearTimeout(timeoutId);
        resolve({
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
          source: "gps",
        });
      },
      () => {
        clearTimeout(timeoutId);
        resolve(null); // denied, unavailable, or timed out — fall through to IP
      },
      { enableHighAccuracy: false, timeout: 7000, maximumAge: 5 * 60 * 1000 }
    );
  });
}

async function tryIP() {
  try {
    const res = await fetch("https://ipapi.co/json/");
    if (!res.ok) return null;
    const data = await res.json();
    if (!Number.isFinite(data.latitude) || !Number.isFinite(data.longitude)) {
      return null;
    }
    return {
      latitude: data.latitude,
      longitude: data.longitude,
      source: "ip",
      city: data.city,
      region: data.region,
    };
  } catch {
    return null;
  }
}

/* ---------- Distance + nearest dealer ---------- */

// Haversine distance in km
function distanceKm(a, b) {
  const R = 6371;
  const toRad = (deg) => (deg * Math.PI) / 180;
  const dLat = toRad(b.latitude - a.latitude);
  const dLng = toRad(b.longitude - a.longitude);
  const lat1 = toRad(a.latitude);
  const lat2 = toRad(b.latitude);

  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.sin(dLng / 2) ** 2 * Math.cos(lat1) * Math.cos(lat2);
  return 2 * R * Math.asin(Math.sqrt(h));
}

async function findNearestDealers({ limit = 5, inStockOnly = false } = {}) {
  const [dealers, user] = await Promise.all([
    fetchDealerLocations(),
    getUserLocation(),
  ]);

  const pool = inStockOnly ? dealers.filter((d) => d.hasStock) : dealers;

  return pool
    .map((d) => ({ ...d, distanceKm: distanceKm(user, d) }))
    .sort((a, b) => a.distanceKm - b.distanceKm)
    .slice(0, limit);
}

/* ---------- localStorage helpers with TTL ---------- */

function readCache(key, ttlMs) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const { savedAt, payload } = JSON.parse(raw);
    if (Date.now() - savedAt > ttlMs) return null;
    return payload;
  } catch {
    return null;
  }
}

function writeCache(key, payload) {
  try {
    localStorage.setItem(
      key,
      JSON.stringify({ savedAt: Date.now(), payload })
    );
  } catch {
    // Quota exceeded or storage disabled — ignore, we'll just re-fetch next time
  }
}

async function renderDealerList() {
  if (!dealerList) return;

  // Loading state
  dealerList.innerHTML = `<p class="dealer-loading">Finding dealers near you…</p>`;

  try {
    const dealers = await findNearestDealers({ limit: 3 });

    const nearby = dealers.filter((d) => d.distanceKm <= MAX_DEALER_DISTANCE_KM);

    let dealersToShow;
    if (nearby.length) {
      dealersToShow = nearby;
    } else {
      const user = await getUserLocation().catch(() => null);
      const fallback = {
        ...FALLBACK_DEALER,
        distanceKm: user ? distanceKm(user, FALLBACK_DEALER) : null,
      };
      dealersToShow = [fallback];
    }

    dealerList.innerHTML = dealersToShow
      .map((dealer) => renderDealerCard(dealer))
      .join("");

    // Wire up the carets
    dealerList.querySelectorAll(".dealer-card").forEach((card) => {
      const header = card.querySelector(".dealer-header");
      header.addEventListener("click", () => {
        card.classList.toggle("expanded");
      });
    });
  } catch (err) {
    console.warn("Dealer lookup failed:", err);
    dealerList.innerHTML = `<p class="dealer-empty">Couldn't load nearby dealers. <button type="button" onclick="renderDealerList()">Try again</button></p>`;
  }
}

function renderDealerCard(dealer, isExpanded = false) {
  const distance = dealer.distanceKm != null
    ? `${dealer.distanceKm.toFixed(1)} km away`
    : "";

  // Build details rows only for fields that exist
  const rows = [];
  if (dealer.address) {
    rows.push(detailRow("location", "Address", dealer.address));
  }
  if (dealer.phone) {
    rows.push(detailRow("phone", "Phone", `<a href="tel:${escapeAttr(dealer.phone)}">${escapeHtml(dealer.phone)}</a>`));
  }
  if (dealer.email) {
    rows.push(detailRow("mail", "Email", `<a href="mailto:${escapeAttr(dealer.email)}">${escapeHtml(dealer.email)}</a>`));
  }
  if (distance) {
    rows.push(detailRow("ruler", "Distance", distance));
  }

  return `
    <div class="dealer-card${isExpanded ? " expanded" : ""}">
      <button type="button" class="dealer-header" aria-expanded="${isExpanded}">
        <div class="dealer-header-text">
          <p class="dealer-name">${escapeHtml(dealer.name)}</p>
          ${distance ? `<p class="dealer-meta">${escapeHtml(distance)}</p>` : ""}
        </div>
        <svg class="dealer-caret" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>
      <div class="dealer-details">
        <div class="dealer-details-inner">
          ${rows.join("")}
        </div>
      </div>
    </div>
  `;
}

function detailRow(icon, label, value) {
  return `
    <div class="dealer-row">
      <span class="dealer-row-label">${label}</span>
      <span class="dealer-row-value">${value}</span>
    </div>
  `;
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}
function escapeAttr(str) {
  return escapeHtml(str);
}

// Kick it off
renderDealerList();